import {Page} from 'utils/page-utils';
import CMSUtils from 'utils/cms';
import {PRISMIC_CUSTOM_TYPE} from 'utils/prismic-types';
import AppRatingAPI from 'api/app-rating';
import JobsAPI from 'api/jobs';

// Takes the route and returns the prismic slug needed
// to retrieve page data (ie. path/some-page => path_some-page)
// can also work on nested paths (ie. path/subpath/some-page => path_subpath_some-page)
export const cleanedSlug = pathname => {
    const parsedPathName = pathname.slice(1).replace(/\//g, '_');

    return parsedPathName.endsWith('_')
        ? parsedPathName.slice(0, -1)
        : parsedPathName;
};

const isCareersPage = pathname => pathname.match(/careers/i);
const pageType = Page.MARKETING;

const getInitialState = async ({state, cookies, route}) => {
    const jobsPromise = isCareersPage(route.location.pathname)
        ? JobsAPI.getJobs()
        : Promise.resolve(null);
    const [page, appRating, jobs] = await Promise.all([
        CMSUtils.getPageData({
            cookies,
            slug: cleanedSlug(route.location.pathname),
            customType: PRISMIC_CUSTOM_TYPE.MARKETING_PAGES,
            pageType,
        }),
        AppRatingAPI.get(),
        jobsPromise,
    ]);

    return {
        ...state,
        page,
        appRating: {...appRating, isPending: false},
        jobs: {
            data: {
                jobs,
                pending: false,
                selectedJob: null,
            },
        },
    };
};

export default getInitialState;
